def.mod('events', context => {
    const { $el, data } = context
    const gevent = data.context

    const click = () => {
        if(window.gtag) {
            gtag('event', gevent.event, {'event_category' : gevent.category,'event_label' : gevent.label });
            console.log('google event tracked', gevent)
        }
        window.uetq = window.uetq || []; 
        window.uetq.push({ 'ec': gevent.event, 'ea': gevent.category, 'el': gevent.label});
    
        const href = $el.attr('href') || data.href || gevent.href

        setTimeout(function() {
            window.location = href
        }, 500)
        return false
    }

    $el.click(click)
})
